import { render, staticRenderFns } from "./EditPostOptions.vue?vue&type=template&id=41b8cbce&scoped=true&"
import script from "./EditPostOptions.vue?vue&type=script&lang=ts&"
export * from "./EditPostOptions.vue?vue&type=script&lang=ts&"
import style0 from "./EditPostOptions.vue?vue&type=style&index=0&id=41b8cbce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b8cbce",
  null
  
)

export default component.exports